import * as React from "react";
import languages from "../../language/languages";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Row, Col, Select } from "antd";
import {reduxForm, Field, formValueSelector} from "redux-form";
import {connect} from "react-redux";
import {push} from "connected-react-router";
import getAllFields from "../../actions/getAllFields";
import generateCertificateFromPKCS10 from "../../actions/generateCertificateFromPKCS10";
import PrivateRoute from "../Main/PrivateRoute";
import forge from "node-forge";
import {CreateTextArea, CreateTextField} from "../../helpers/InputCreator";
import {required, requireden} from "../../helpers/validations";
import certificateTypes from "../../language/certificateTypes";
import countries from "../../language/countries";
import PublicLayout from "../Layouts/Public";

class CertRequestPKCS10 extends React.Component
{
    preffix='_npki_';
    customFields=[];
    componentDidMount()
    {
        this.props.getAllFields(this.initialize);
    }

    initialize=(fields)=>
    {
        let general=this;
        let initialValues={type: 'mime',areaCode:'57'};
        let defaultFields=['type','cn','email','cedula','direccion','country','state','city','organization','organizationalUnit','areaCode','telefono'];
        fields.forEach(function(field)
        {
            if(!defaultFields.includes(field.id))
            {
                general.customFields.push(field);
                if(field.type===1)
                    initialValues[general.getNewID(field.id)] = "0";
            }

        });
        this.props.initialize(initialValues);
    };

    getNewID=(oldID)=>
    {
        return oldID.split('.').join(this.preffix);
    };

    sendCSR = (form) =>
    {
        let general=this;
        let newForm={...form};
        let customFieldsJSON={};
        this.customFields.forEach(function(customField)
        {
            let oldKey=customField.id.split('.').join(general.preffix);
            let customValue=newForm[oldKey];
            delete newForm[oldKey];
            if(customField.type===1)
            {
                let customValues=JSON.parse(customField.values)[general.props.language].split(':');
                customValue=customValues[customValue];
            }
            customFieldsJSON[customField.id]=customValue;
        });
        let phone=newForm.telefono;
        if(phone && phone!=='' && !phone.startsWith('+'))
            phone='+'.concat(newForm.areaCode).concat('-').concat(phone);
        newForm.telefono=phone;
        delete newForm.areaCode;
        delete newForm.subject;
        newForm.customFieldsJSON=JSON.stringify(customFieldsJSON);
        newForm.csr=btoa(unescape(encodeURIComponent(newForm.csr)));
        this.props.generateCertificateFromPKCS10(newForm);
    };

    validateCSR = (csrText) =>
    {
        if(!csrText || csrText==='')
            return;
        let newSubject = '';
        try
        {
            let modifiedCSR = csrText.replace('BEGIN NEW CERTIFICATE REQUEST', 'BEGIN CERTIFICATE REQUEST');
            modifiedCSR = modifiedCSR.replace('END NEW CERTIFICATE REQUEST', 'END CERTIFICATE REQUEST');
            let csr = forge.pki.certificationRequestFromPem(modifiedCSR);
            let subject='';
            let equalSign = '=';
            let commaSign = ',';
            let general=this;
            csr.subject.attributes.forEach(function (attribute) {
                let attrValue=attribute.value;
                let shortName=attribute.shortName;
                if(!shortName || shortName==='')
                {
                    let type=attribute.type;
                    switch(type)
                    {
                        case '0.9.2342.19200300.100.1.1':
                            shortName='uid';
                            general.props.change('cedula',attrValue);
                            break;
                        case '2.5.4.9':
                            shortName='streetAddress';
                            general.props.change('direccion',attrValue);
                            break;
                        default:
                            console.log("Unknown type ignored: " + type);
                    }
                }
                if(shortName && shortName!=='')
                    subject = subject.concat(shortName).concat(equalSign).concat(attrValue).concat(commaSign);
            });
            newSubject=subject.substring(0, subject.length - 1);
            newSubject=this.decode_utf8(newSubject);
        } catch (e)
        {
            console.log("Error",e.message);
        }
        this.props.change('subject',newSubject);
    };

    decode_utf8=(s)=>
    {
        return decodeURIComponent(escape(s));
    }

    renderSelectOptions=(field)=>
    {
        if(field.type===0)
            return '';
        switch (field.id)
        {
            case "type":
                return certificateTypes[this.props.language].map(item => item.code === 'ALL' ? '' : <Select.Option key={item.code}>{item.name}</Select.Option>);
            case "areaCode":
                return countries.map(country =>country.dialcode==='*'?'':<Select.Option key={country.dialcode}>({country.dialcode}) - {country.name}</Select.Option>);
            default:
                if(field.values)
                {
                    let jsonValues=JSON.parse(field.values)[this.props.language];
                    return jsonValues.split(':').map((value,index) => <Select.Option key={index}>{value}</Select.Option>);
                }
                return '';
        }
    };

    renderFormItem=(field,data) =>
    {
        data.input.onBlur=null;
        const hasError = data.meta.touched && data.meta.invalid;
        return <Form.Item
            label={data.label}
            className={data.icon ? '' : 'no-icon'}
            validateStatus={hasError ? "error" : "success"}
            hasFeedback={data.hasFeedback && hasError}
            help={hasError && data.meta.error}
            {...data.rest}
        ><Select label={data.label} {...data.input} {...data.rest}>{this.renderSelectOptions(field)}</Select></Form.Item>;
    };

    renderFields= () =>
    {
        if(!this.props.fields || this.props.fields.length<=0)
            return '';
        let fieldsToIgnore=['cn','email','country','state','city','organization','organizationalUnit'];
        return this.props.fields.map((field)=> {
            let fieldID=field.id;
            if(fieldsToIgnore.includes(fieldID))
                return '';
            let fieldLabel = languages[this.props.language][fieldID];
            if(!fieldLabel||fieldLabel==='')
                fieldLabel=JSON.parse(field.label)[this.props.language];
            let newID=this.getNewID(fieldID);
            return <Row  gutter={24}><Col style={{marginTop: 7}} span={4}>{fieldLabel}</Col>
                <Col span={20}><Field placeholder={fieldLabel} name={newID} component={field.type===0?CreateTextField:(data)=>this.renderFormItem(field,data)}
                                           hasFeedback>
                </Field></Col></Row>
        });
    };

    renderForm=()=>
    {
        return <Form onSubmit={this.props.handleSubmit(this.sendCSR)}>
            <Row gutter={24}>
                <Col style={{marginTop: 7}} span={4}>
                    {languages[this.props.language].csrLabel}
                </Col>
                <Col span={20}>
                    <Field
                        name="csr"
                        rows={19}
                        style={{fontSize:12, resize:'none'}}
                        component={CreateTextArea}
                        placeholder={languages[this.props.language].pkcs10PlaceHolder}
                        onChange={(event) => {
                            this.validateCSR(event.target.value)
                        }}
                        hasFeedback/>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col style={{marginTop: 7}} span={4}>
                    {languages[this.props.language].pkcs10Subject}
                </Col>
                <Col span={20}>
                    <Field
                        name="subject"
                        style={{resize:'none'}}
                        disabled={true}
                        rows={2}
                        component={CreateTextArea}
                        validate={[this.props.language==='es'?required:requireden]}
                        hasFeedback/>
                </Col>
            </Row>
            {!this.props.subject || this.props.subject===''?'':this.renderFields()}
            {!this.props.subject || this.props.subject===''?'':<Form.Item className={'text-center'}>
                <Button  type="primary" htmlType="submit" className={'light-blue rounded'}>
                    {languages[this.props.language].pkcs10Generate}
                </Button>
            </Form.Item>}
            {this.props.logged?'':<Form.Item className={'text-center'}>
                <Button onClick={()=>{this.props.push('/')}} type="primary" className={'light-blue rounded'}>
                    {languages[this.props.language].goBack}
                </Button>
            </Form.Item>}
        </Form>
    };

    render() {
        if(this.props.logged) {
            return <div className="card-container h-100 p-20 tabs-container">
                {this.renderForm()}
            </div>;
        }
        return <PublicLayout isRA={this.props.isRA} title={'logo'}>
            <br/>
            <br/>
            {this.renderForm()}
        </PublicLayout>;
    }
}

const mapStateToProps = state => {
    const selector = formValueSelector('newReqPKCS10_form');
    return {
        language: state.auth.language,
        logged:state.auth.logged,
        isRA:state.auth.isRA,
        fields: state.certificates.fields,
        subject:selector(state,'subject')
    };
};

export default PrivateRoute(connect(mapStateToProps, {
    push,
    getAllFields,
    generateCertificateFromPKCS10
})((reduxForm({form: 'newReqPKCS10_form'})(CertRequestPKCS10))));
